import React, { FC, useEffect, useState } from 'react';
import useLocales from 'hooks/useLocales';
import {
  Table as MUITable,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip
} from '@mui/material';
import Image from 'components/image/Image';
import { SubscribtionPlansService } from 'services/subscribtionPlans/subscribtionPlans';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import './Index.scss';

const OrderHistory: FC = (): JSX.Element => {
  const [invoiceData, setInvoiceData] = useState<any[]>([]);
  const { t } = useLocales();

  const [copiedId, setCopiedId] = useState<string | null>(null);

  const handleGetOrderHistory = async () => {
    try {
      const invoiceResponse = await SubscribtionPlansService.getInvoiceData();

      const invoices = Array.isArray(invoiceResponse)
        ? invoiceResponse
        : invoiceResponse?.invoices || [];
      setInvoiceData(invoices);
    } catch (e) {
      setInvoiceData([]);
    }
  };

  useEffect(() => {
    handleGetOrderHistory();
  }, []);

  const headerStyle = {
    backgroundColor: '#33B1E8',
    fontSize: 16,
    fontWeight: 600,
    color: '#FFFFFF',
    whiteSpace: 'nowrap'
  };

  const bodyStyle = {
    background: '#EEF5F8',
    boxShadow: 'none',
    color: '#2A2A2A',
    fontSize: 16
  };

  return (
    <>
      {invoiceData.length < 1 ? (
        <div className="no-invoice">
          <span className="no-invoice-title">{t('No invoice')}</span>
        </div>
      ) : (
        <div className="container">
          <div className="title">{t('Order history')}</div>
          <TableContainer
            component={Paper}
            sx={{ border: 'none', boxShadow: 'none', padding: '0 30px 30px' }}
          >
            <MUITable className="modern-gap-table">
              <TableHead>
                <TableRow>
                  <TableCell sx={headerStyle}>{t('Date')}</TableCell>
                  <TableCell sx={headerStyle}>{t('Invoice number')}</TableCell>
                  <TableCell sx={headerStyle}>{t('Total')}</TableCell>
                  <TableCell sx={headerStyle}>{t('Status')}</TableCell>
                  <TableCell sx={headerStyle}>{t('PDF')}</TableCell>
                  <TableCell sx={headerStyle}>{t('Details')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceData?.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell
                      sx={{
                        ...bodyStyle,
                        padding: '12px 20px',
                        border: 'none'
                      }}
                    >
                      {row.created_on
                        ? new Date(row.created_on * 1000).toLocaleString()
                        : ''}
                    </TableCell>
                    <TableCell
                      sx={{
                        ...bodyStyle,
                        color: '#33B1E8',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        padding: '12px 20px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                      }}
                    >
                      <span
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          flex: 1
                        }}
                      >
                        {row.id}
                      </span>
                      <Tooltip
                        title={
                          copiedId === row.id
                            ? t('copied')
                            : t('copy_invoice_number')
                        }
                        arrow
                      >
                        <IconButton
                          size="small"
                          onClick={() => {
                            navigator.clipboard.writeText(row.id);
                            setCopiedId(row.id);
                            setTimeout(() => setCopiedId(null), 1200);
                          }}
                          sx={{ ml: 1 }}
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                    <TableCell
                      sx={{
                        ...bodyStyle,
                        padding: '12px 20px',
                        border: 'none'
                      }}
                    >
                      €{row.amount}
                    </TableCell>
                    <TableCell
                      sx={{
                        ...bodyStyle,
                        padding: '12px 20px',
                        border: 'none'
                      }}
                    >
                      {row.status}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        ...bodyStyle,
                        padding: '12px 20px',
                        border: 'none'
                      }}
                    >
                      {row.pdf ? (
                        <a
                          href={row.pdf}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Image
                            width={20}
                            height={20}
                            name="credit-card.svg"
                          />
                        </a>
                      ) : (
                        ''
                      )}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        ...bodyStyle,
                        padding: '12px 20px',
                        border: 'none'
                      }}
                    >
                      {row.url ? (
                        <a
                          href={row.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="details-btn"
                          style={{
                            textDecoration: 'none',
                            color: '#33B1E8',
                            fontWeight: 600
                          }}
                        >
                          {t('View more details')}
                        </a>
                      ) : null}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </MUITable>
          </TableContainer>
        </div>
      )}
    </>
  );
};

export default OrderHistory;
